module.exports = __webpack_public_path__ + "img/Entra-a-far-parte-della-community.f381750d.png";